// Native
import {
    Box,
    Link,
    Button,
    ButtonGroup,
    DialogBody,
    DialogFooter,
    HStack,
    Image,
    Separator,
    Stack,
    Text
} from "@chakra-ui/react"
import {useNavigate, useLocation} from "react-router"

// Custom
import {UI} from "components"
import useUser from "hooks/useUser"
import {useData} from "hooks/useData"
import {useState} from "react"
import {API} from "config"
import {toaster} from "config"

export default function Nav() {

    const {drawer, closeDrawer} = useData()

    return (
        <>
            <Menu/>
            <UI.Drawer size="xs" placement="start" open={drawer} onClose={closeDrawer}><Menu/></UI.Drawer>
        </>
    )
}

const Menu = () => {

    const user = useUser()
    const customer_options = user.data?.options;
    const consultant_options = user.data?.consultant?.options;

    return (
        <Box maxH="100%" overflowX="hidden">
            <Stack gap={4} p={4}>
                <HStack>
                    <Image src="/icon.png" h="50px"/>
                    <Box>
                        <Text children="Bonífica"/>
                        <Text fontSize="xs" color="GrayText" children="Escritório de consultor" mt="-4px"/>
                    </Box>
                </HStack>

                <Separator/>

                <HStack>
                    <UI.Avatar src={user.data?.avatar_url} name={user.data?.name} colorPalette="orange"/>
                    <Box>
                        <Text fontSize="sm" fontWeight="bold" children={user.data?.name}/>
                        <Text fontSize="small" children={user.data?.consultant?.career?.current_career?.title}
                              color="GrayText"/>
                    </Box>
                </HStack>

                <Separator/>

                <UI.Show visible={consultant_options?.adhesion === 'required'}>
                    <MenuItem path="/adesao" title="Adesão" icon="user"/>
                    <Separator/>
                    <MenuItem path="/logout" title="Sair" icon="logout" colorPalette="red"/>
                </UI.Show>

                <UI.Show
                    visible={consultant_options?.adhesion !== 'required' && customer_options?.identity === 'waiting'}>
                    <MenuItem path="/identidade" title="Identidade" colorPalette="red" icon="identity"/>
                    <Separator/>
                </UI.Show>

                <UI.Show visible={consultant_options?.adhesion !== 'required'}>
                    <Stack>
                        <MenuItem path="/" title="Início" icon="home"/>
                        <MenuItem path="/perfil" title="Meu perfil" icon="profile"/>
                        <MenuItem path="/financeiro" title="Contas & Saques" icon="withdraw"/>
                        <MenuItem path="/bonus" title="Bonificações" icon="bonus"/>
                        <MenuItem path="/rede" title="Rede" icon="network"/>
                        <MenuItem path="/pontos" title="Pontuação" icon="points"/>
                        <MenuItem path="/loja" title="Loja" icon="store"/>
                        <MenuItem path="/pedidos" title="Pedidos" icon="orders"/>
                        <MenuItem path="/vouchers" title="Vouchers" icon="vouchers"/>

                        <Separator/>

                        <MenuItem path="/ajustes" title="Ajustes" icon="settings"/>
                        <Box
                            w="100%"
                            py={2}
                            px={4}
                            cursor="pointer"
                            borderRadius={4}
                            backgroundColor={{base: null, _hover: `green.400`}}
                            color={{base: null, _hover: 'white'}}
                            borderLeftWidth={2}
                            borderLeftColor={'transparent'}
                            onClick={() => window.open('https://api.whatsapp.com/send?phone=556299555388&text=Preciso%20de%20ajuda', '_blank')}
                        >
                            <HStack>
                                <UI.Icon name="whatsapp"/>
                                <Text children="Suporte" fontSize="sm" color="dark:gray.100 dark:gray.700"/>
                            </HStack>
                        </Box>
                    </Stack>
                </UI.Show>

                <Separator/>

                <Text fontSize="xs" color="GrayText"><Link href="/termos">Termos</Link> &bull; <Link
                    href="https://bonificaoficial.com" target="_blank">Website</Link> &bull; <Link
                    href="https://instagram.com/oficialbonifica" target="_blank">Instagram</Link></Text>

                <Separator/>

                <Box>
                    <Text fontSize="xs" children="Bonífica 2026 - Todos os direitos reservados" color="white"/>
                    <Text fontSize="xs" children="Versão 250701.0025" color="white"/>
                </Box>

            </Stack>
            <DialogTerms/>
            <UI.Show visible={!!user.data && !user.data?.options?.terms}><DialogTerms/></UI.Show>
        </Box>
    )
}

const MenuItem = ({title, icon, path, colorPalette = 'orange', ...props}) => {

    const location = useLocation()
    const navigate = useNavigate()
    const {closeDrawer} = useData()

    const active = path === location.pathname

    const handleNavigate = path => {
        navigate(path)
        closeDrawer()
    }

    return (
        <Box
            w="100%"
            py={2}
            px={4}
            cursor="pointer"
            borderRadius={4}
            backgroundColor={
                {
                    base: active ? 'bg.muted' : null,
                    _hover: `${colorPalette}.400`
                }
            }
            color={{base: null, _hover: 'white'}}
            borderLeftWidth={2}
            borderLeftColor={active ? `${colorPalette}.300` : 'transparent'}
            onClick={() => handleNavigate(path)}
            {...props}
        >
            <HStack>
                <UI.Icon name={icon} color={active ? `${colorPalette}.100` : null}/>
                <Text children={title} fontSize="sm" color={active ? null : 'dark:gray.100 dark:gray.700'}/>
            </HStack>
        </Box>
    )
}

const DialogTerms = ({open = false}) => {

    const user = useUser()
    const [loading, setLoading] = useState(false)

    const handleAccept = async () => {
        setLoading(true)

        try {
            await API.put('/me/terms')
            toaster.create({title: 'Termos de utilização aceitos com sucesso. Seja bem vindo(a)!', type: 'success'})
            await user.refetch()
        } catch (err) {
            toaster.create({title: 'Não foi possível continuar agora. Tente novamente', type: 'error'})
        }
    }

    return (
        <UI.Dialog open={open} title="Termos de Utilização do Escritório de Consultor">
            <DialogBody>
                <Stack>
                    <Text>Para continuar a utilização do seu novo escritório de consultor, antes você deve confirmar que
                        leu e concorda com os <b>Termos de Uso</b> da Bonífica.</Text>
                    <Separator/>
                    <UI.Terms/>
                </Stack>
            </DialogBody>
            <DialogFooter>
                <ButtonGroup>
                    <Button colorPalette="green" loading={loading} loadingText="Salvando assinatura..."
                            onClick={handleAccept}><UI.Icon name="check"/>Confirmo que li e concordo com os
                        termos</Button>
                    <Button disabled={loading} variant="ghost" colorPalette="red"><UI.Icon name="logout"/> Sair</Button>
                </ButtonGroup>
            </DialogFooter>
        </UI.Dialog>
    )
}
